import FormCheckboxFieldDark from "@/components/UI/FormCheckboxFieldDark/FormCheckboxFieldDark";
import { ELEMENT_POSITIONING } from "@/constants";

export default function ElementPositioningField(props) {
  const { formValues, setValue, disabled, type } = props;
  const { positioning } = formValues;

  return (
    <FormCheckboxFieldDark
      label="Display on entire experience"
      onChange={() =>
        setValue(
          "positioning",
          positioning === ELEMENT_POSITIONING.EXPERIENCE ? ELEMENT_POSITIONING.CONTENT : ELEMENT_POSITIONING.EXPERIENCE,
          { shouldDirty: true },
        )
      }
      checked={positioning === ELEMENT_POSITIONING.EXPERIENCE}
      disabled={disabled}
      data-testid="element-positioning-field"
      data-analytics={`${type}-checkbox-display-all`}
    />
  );
}
